import { SectionTag, GlassCard } from "../../components/ui";
import MapView from "../map/MapView";

export default function Geospatial() {
  return (
    <div className="flex h-full min-h-0 flex-col gap-3">
      <div>
        <SectionTag>GEOSPATIAL · OPERATING PICTURE</SectionTag>
        <h1 className="text-xl font-semibold">Geospatial Workspace</h1>
        <p className="text-sm text-slatey">
          Clustered exceptions, density heatmap, site safety choropleth and live assets —
          viewport-bound &amp; date-filtered. Click a cluster to zoom, a pin to open the case.
        </p>
      </div>
      <GlassCard className="min-h-0 flex-1 overflow-hidden bg-ocean-900/40 p-0">
        <MapView variant="full" />
      </GlassCard>
    </div>
  );
}
